import React from "react";
import "twin.macro";
import { Image, message, Tooltip } from "antd";
import copy from "../../assets/svg/copy.svg";

const CopyToClipboard = ({ text }) => {
	return (
		<Tooltip title="Copy to clipboard" color={"red"}>
			<span>
				<Image
					preview={false}
					src={copy}
					alt=""
					width={18}
					height={20}
					tw="cursor-pointer"
					onClick={() => {
						navigator.clipboard.writeText(text);
						message.success("Copied to clipboard");
					}}
				/>
			</span>
		</Tooltip>
	);
};

export default CopyToClipboard;
